import "./SobreCata.css";
import useParallax from "../Animaciones/useParallax";
import AnimarAlScroll from "../Animaciones/AnimarAlScroll";

function SobreCata() {
  const parallaxFoto = useParallax(0.08, 24);

  return (
    <section className="sobre-cata" id="sobre-cata">
      <AnimarAlScroll>
      <div className="contenedor">
        <div className="sobre-cata-contenido">

          <div className="sobre-cata-imagen-contenedor">
            <div className="sobre-cata-imagen">
              <img
                ref={parallaxFoto}
                src="/cata2.jpg"
                alt="Cata - Glowroom MVD"
                className="sobre-cata-foto"
                loading="lazy"
              />
            </div>
        
          </div>

          <div className="sobre-cata-texto">
            <div className="seccion-titulo" style={{ textAlign: "left" }}>
              <h2>Conocé a Cata ♡</h2>
            </div>

            <p className="sobre-parrafo">
              Soy Cata, la persona detrás de GlowRoom.
            </p>

            <p className="sobre-parrafo">
              GlowRoom nació de mi amor por la belleza, sí, pero con el tiempo
              entendí que quería que fuera mucho más que un lugar donde venir
              a hacerse las uñas, las pestañas o las cejas.
            </p>

            <p className="sobre-parrafo sobre-parrafo-destacado">
              <span className="sobre-destello">Quiero que venir acá sea tu momento.</span>
            </p>

            <p className="sobre-parrafo">
              Que puedas llegar como estés, sentarte, charlar, reírte,
              desconectar un rato y sentirte cómoda. Que no sientas que sos
              "un turno más", sino que estás en un espacio donde te conocen,
              te escuchan y saben qué te gusta.
            </p>

            <p className="sobre-parrafo">
              Soy muy detallista con mi trabajo y me importa muchísimo que el
              resultado quede hermoso, prolijo y que realmente te represente.
              Pero para mí, la calidad no termina en el resultado: también
              está en cómo te sentís mientras estás acá.
            </p>

            <p className="sobre-parrafo">
              Quiero que GlowRoom sea ese lugar al que tenés ganas de volver.
              No solamente porque amaste cómo quedaron tus uñas o tus
              pestañas, sino porque la pasaste bien, te sentiste linda y te
              fuiste sintiéndote mucho mejor de lo que llegaste.
            </p>

            <p className="sobre-cierre">Ese es el verdadero glow. ♡</p>
            <p className="sobre-cierre sobre-cierre-secundario">
              <span className="sobre-destello">Venís por el resultado, volvés por cómo te sentís.</span>
            </p>
          </div>

        </div>
      </div>
      </AnimarAlScroll>
    </section>
  );
}

export default SobreCata;